// Story 7.16 (ADO-1373) — code review follow-up. Coordinates the category-listing
// Stock Card popover across cards so at most one is open at a time, mirroring the
// single-open-slot shape `useUpsellModalStore` already uses for its ONE dialog.
//
// Before this, `stockCardOpen` was local `useState` per `ProductCard`, and each
// mounted `Popover` registered its own `document`-level Escape/outside-click
// listeners with no coordination between cards: opening a second card's popover
// via keyboard (Enter/Space fires a `click`, not the `mousedown` the first
// popover's outside-click guard listens for) left the first one open too, and a
// single Escape press then closed BOTH at once. `ProductCard`'s own comment already
// assumed "one open card at a time" without anything enforcing it.

import { create } from 'zustand';

interface StockCardPopoverState {
  /** The SKU whose Stock Card popover is open, or `null` when none is. */
  readonly openSku: string | null;
  /** Open `sku`'s popover, closing any other card's in the same commit. */
  open: (sku: string) => void;
  /**
   * Close `sku`'s popover — a no-op if a DIFFERENT sku is now open (e.g. this
   * card's own close ran after another card already took the slot).
   */
  close: (sku: string) => void;
  /** Test/session hygiene — drop all state. */
  reset: () => void;
}

export const useStockCardPopoverStore = create<StockCardPopoverState>((set) => ({
  openSku: null,
  open: (sku) => set({ openSku: sku }),
  close: (sku) => set((state) => (state.openSku === sku ? { openSku: null } : state)),
  reset: () => set({ openSku: null }),
}));
